export default "__VITE_ASSET__IQbs7Mpt__"